import * as React from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import "../../../../src/App.css"
import uploadIcon from "../../../asset/images/portal/upload.png"
import { useEffect, useState, useRef } from 'react';
import { Cropper } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';
import { uploadSign, uploadPhoto, fetchStudentPhoto, fetchStudentSign } from "../../api/studentDetails"

const MAX_IMAGE_SIZE_KB = 200;
function PhotoSignDetails() {
    const [photo, setPhoto] = useState(null);
    const [sign, setSign] = useState(null);
    const [error, setError] = useState('');
    const [photoUrl, setPhotoUrl] = useState(null);
    const [signUrl, setSignUrl] = useState(null);
    const photoCropperRef = useRef(null);
    const signCropperRef = useRef(null);
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const studentId = localStorage.getItem("id");
    console.log("Student id for photo and sign:", studentId);

    useEffect(() => {
        const fetchExistingImages = async () => {
            if (studentId) {
                try {
                    const photoResponse = await fetchStudentPhoto(token, studentId);
                    if (photoResponse.status === 200) {
                        const photoBlob = new Blob([photoResponse.data], { type: 'image/jpeg' });
                        const photoUrl = URL.createObjectURL(photoBlob);
                        setPhotoUrl(photoUrl);
                    } else {
                        console.log("No photo found for this student.");
                    }

                    const signResponse = await fetchStudentSign(token, studentId);

                    if (signResponse.status === 200) {
                        const signBlob = new Blob([signResponse.data], { type: 'image/jpeg' });
                        const signUrl = URL.createObjectURL(signBlob);
                        setSignUrl(signUrl);

                    } else {
                        setError("No signature found for this student.");
                    }
                } catch (error) {
                    setError("Error fetching existing images:", error);
                }
            }
        };
        fetchExistingImages();
    }, [studentId, token]);

    // const handlePhotoChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileSizeKB = file.size / 1024;
    //         if (fileSizeKB <= MAX_IMAGE_SIZE_KB) {
    //             setPhoto(file);

    //         } else {
    //             setPhoto(null);
    //             toast.error("Photo size exceeds 200kb limit");
    //         }
    //     } else {
    //         setPhoto(null);
    //     }
    // };

    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setPhoto(null);
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        const isValidType = allowedTypes.includes(file.type);
        const isValidExtension = ['jpg', 'jpeg', 'png'].includes(fileExtension);

        if (!isValidType || !isValidExtension) {
            setPhoto(null);
            toast.error("Only image files are allowed (.jpg, .jpeg, .png)");
            return;
        }

        const fileSizeKB = file.size / 1024;
        if (fileSizeKB > MAX_IMAGE_SIZE_KB) {
            setPhoto(null);
            toast.error("Photo size exceeds 200kb limit");
            return;
        }

        setPhoto(file);
    };


    // const handleSignatureChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileSizeKB = file.size / 1024;
    //         if (fileSizeKB <= MAX_IMAGE_SIZE_KB) {
    //             setSign(file);
    //         } else {
    //             setSign(null);
    //             alert("Signature size exceeds 200kb limit");
    //         }
    //     } else {
    //         setSign(null);
    //     }
    // };

    const handleSignatureChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setSign(null);
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        const isValidType = allowedTypes.includes(file.type);
        const isValidExtension = ['jpg', 'jpeg', 'png'].includes(fileExtension);

        if (!isValidType || !isValidExtension) {
            setSign(null);
            toast.error("Only image files are allowed (.jpg, .jpeg, .png)");
            return;
        }

        const fileSizeKB = file.size / 1024;
        if (fileSizeKB > MAX_IMAGE_SIZE_KB) {
            setSign(null);
            toast.error("Signature size exceeds 200kb limit");
            return;
        }

        setSign(file);
    };



    const getCroppedImageBlob = async (cropperRef) => {
        if (cropperRef.current) {
            const canvas = cropperRef.current.getCanvas();
            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, "image/jpeg");

            });
        }
        return null;
    };

    const handleUploadPhoto = async () => {
        if (!studentId) {
            toast.error("No student selected for photo upload.");
            return;
        }

        if (!photo) {
            toast.error("Please select a photo before uploading.");
            return;
        }
        try {
            const croppedPhoto = await getCroppedImageBlob(photoCropperRef);
            if (!croppedPhoto) {
                toast.alert("Failed to crop photo.");
                return;
            }
            const response = await uploadPhoto(studentId, croppedPhoto, token);
            if (response.status === 200) {
                const photoUrl = response.data.url || URL.createObjectURL(croppedPhoto);
                console.log("Photo upload res:", photoUrl)
                setPhotoUrl(photoUrl);
                toast.success("Photo Uploaded Successfully.");
                console.log("Cropped Photo:", croppedPhoto);
            } else {
                toast.error("Failed to upload photo to the server.");
            }
            setPhoto(null);
        } catch (error) {
            toast.error("Error uploading photo: " + (error.response ? error.response.data : error.message));
        }
    };

    const handleUploadSign = async () => {
        if (!studentId) {
            toast.error("No student selected for signature upload.");
            return;
        }

        if (!sign) {
            toast.error("Please select a sign before uploading.");
            return;
        }
        try {
            const croppedSign = await getCroppedImageBlob(signCropperRef);
            if (!croppedSign) {
                toast.alert("Failed to crop signature.");
                return;
            }
            const response = await uploadSign(studentId, croppedSign, token);
            if (response.status === 200) {
                const signUrl = response.data.url || URL.createObjectURL(croppedSign);
                setSignUrl(signUrl);
                toast.success("Signature Uploaded Successfully.");
                console.log("Cropped sign:", croppedSign);
            } else {
                toast.error("Failed to upload signature to the server.");
            }
            setSign(null);
        } catch (error) {
            toast.error("Error uploading signature: " + (error.response ? error.response.data : error.message));
        }
    };


    useEffect(() => {
        return () => {
            if (photoUrl) URL.revokeObjectURL(photoUrl);
            if (signUrl) URL.revokeObjectURL(signUrl);
        };
    }, [photoUrl, signUrl]);

    return (
        <>
            <Container fluid>
                <Row className="mb-8 mt-4">
                    <Col>
                        <Card>
                            <Card.Body>
                                <div>
                                    <Form>
                                        <div style={{ textAlign: "center" }}>
                                            <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                                className='mb-3  mt-2'>Upload Photo and Signature</Form.Label>
                                        </div>

                                        <Row className="mb-3">
                                            <Col>
                                                <Card>
                                                    <div style={{ textAlign: "center" }}>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col>
                                                                    <Form.Group controlId="formFile" className="mb-3">
                                                                        <Form.Label style={{ color: "#6e48aa", fontWeight: "600" }}>Upload Photo<span className="text-danger">*</span></Form.Label>

                                                                        <Form.Control
                                                                            type="file"
                                                                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                                            onChange={handlePhotoChange}
                                                                            className="mb-4 mt-4"
                                                                        />
                                                                        {photo && (
                                                                            <Cropper
                                                                                ref={photoCropperRef}
                                                                                image={photo}
                                                                                width={150}
                                                                                height={150}
                                                                                cropRatio={1}
                                                                                maxZoom={10}
                                                                                src={URL.createObjectURL(photo)}
                                                                                className={"cropper"}
                                                                                style={{ width: "150px", height: "150px" }}
                                                                            />
                                                                        )}
                                                                    </Form.Group>
                                                                    {photoUrl && (
                                                                        <div>
                                                                            {photoUrl && (
                                                                                <div>
                                                                                    <h5>Uploaded Photo:</h5>
                                                                                    <img src={photoUrl} alt="Student"
                                                                                        style={{ width: '150px', height: '150px' }} />
                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Button className='mt-4'
                                                                variant="primary"
                                                                type="button"
                                                                onClick={handleUploadPhoto}
                                                            >
                                                                Upload
                                                            </Button>
                                                            <ToastContainer />
                                                        </Card.Body>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card>
                                                    <div style={{ textAlign: "center" }}>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col>
                                                                    <Form.Group controlId="formFile" className="mb-3">
                                                                        <Form.Label style={{ color: "#6e48aa", fontWeight: "600" }}>Upload Signature<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control
                                                                            type="file"
                                                                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                                            onChange={handleSignatureChange}
                                                                            className="mb-4 mt-4"
                                                                        />
                                                                        {sign && (
                                                                            <Cropper
                                                                                ref={signCropperRef}
                                                                                image={sign}
                                                                                width={150}
                                                                                height={150}
                                                                                cropRatio={1}
                                                                                maxZoom={10}
                                                                                src={URL.createObjectURL(sign)}
                                                                                className={"cropper"}
                                                                                style={{ width: "150px", height: "150px" }}
                                                                            />
                                                                        )}
                                                                    </Form.Group>
                                                                    {signUrl && (
                                                                        <div>
                                                                            <h5>Uploaded Signature:</h5>
                                                                            <img src={signUrl} alt="Signature"
                                                                                style={{ width: '150px', height: '150px' }} />
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Button className='mt-4'
                                                                variant="primary"
                                                                type="button"
                                                                onClick={handleUploadSign}
                                                            >
                                                                Upload
                                                            </Button>
                                                        </Card.Body>
                                                    </div>
                                                </Card>

                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

// PhotoSignDetails.propTypes = {
//     selectedStudent: PropTypes.shape({
//         id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//         studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     }).isRequired,
// };

export default PhotoSignDetails;